module.exports = __webpack_public_path__ + "img/male-newborn-head.ee01b73b.svg";